import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { OrderDetailsResponse, OrdersService } from '@src/app/shared/backend/clients';
import { OrderState } from '@src/app/shared/enums/OrderState.enum';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { ToasterService } from '@src/app/shared/components/toaster/toaster.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-code-order',
    templateUrl: './view-code-order.component.html',
    styleUrl: './view-code-order.component.scss',
    host: {
        class: 'app-view-code-order'
    },
    standalone: false
})
export class ViewCodeOrderComponent extends BaseViewComponent implements OnInit {

  private readonly destroyedComponent$ = new Subject<void>();

  allowDownloadOrder: boolean = false;
  allowViewUser: boolean = false;
  allowViewProduct: boolean = false;
  codeOrderId: number = 0;
  codeOrder: OrderDetailsResponse = {
    id: 0,
    quantity: 0,
    codeType: 'UNKNOWN',
    algorithmType: 'SEQUENTIAL',
    outputFormatType: 'MANUAL',
    state: 'REQUESTED',
    companyId: 0,
    companyName: '',
    createdOn: '',
    createdById: '',
    createdByFullName: ''
  };
  codeOrderState = OrderState;
  displayAddItemsModalbox: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private ordersService: OrdersService,
    private permissionService: PermissionService,
    private changeDetector: ChangeDetectorRef) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params
      .pipe(takeUntil(this.destroyedComponent$))
      .subscribe(async (params) => {
        this.codeOrderId = Number(params['codeOrderId']);
        if (this.codeOrderId > 0) {
          await this.get();
        }
      });

    this.allowDownloadOrder = await this.permissionService.hasActionPermissions(Actions.download_orders);
    this.allowViewUser = await this.permissionService.hasActionPermissions(Actions.view_users);
    this.allowViewProduct = await this.permissionService.hasActionPermissions(Actions.view_products);
  }

  override async get() {
    try {
        this.codeOrder = await firstValueFrom(this.ordersService.apiOrdersDetailsIdGet(this.codeOrderId));
      } catch (error) {
        console.error('Error fetching code order data:', error);
      } finally {
        this.changeDetector.detectChanges();
      }
  }

  isDownloadDisabled(): boolean {
    return this.codeOrder.state !== OrderState.CODE_ORDER_PROCESSED && this.codeOrder.state !== OrderState.CODE_ORDER_DOWNLOADED;
  }

  async downloadCodeOrderFile() {
    this.ordersService.apiOrdersDownloadIdGet(this.codeOrderId).subscribe({
      next: (response: any) => {
        const fileUrl = response.url;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = `order_${this.codeOrderId}_codes.zip`;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error: (err: any) => {
        console.error('Error during file download', err);
        this.toasterService.show('error', 'Error', err, 3000);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyedComponent$.next();
    this.destroyedComponent$.complete();
  }
}
